import { toRem } from "../../../helpers/theme";

/* eslint-disable quote-props, no-dupe-keys, max-len */
const style = ({ theme }) => ({
    "& .tagsSectionInner": {
        display: "flex",
        flexDirection: "column",
        [theme.breakpoints.up("lg")]: {
            flexDirection: "row",
        },
    },
    "& .tagsSectionHead": {
        display: "inline-flex",
        flex: "0 0 auto",
        marginBottom: toRem(20),
        [theme.breakpoints.up("lg")]: {
            marginBottom: "unset",
        },
    },
    "& .tagsSectionContent": {
        display: "flex",
        alignItems: "flex-end",
        marginTop: toRem(5),
        paddingBottom: toRem(5),
    },
    "& .tagsSectionTitle": {
        marginBottom: toRem(10),
        marginRight: toRem(20),
        [theme.breakpoints.up("lg")]: {
            marginBottom: 0,
        },
        "& > a": {
            color: "inherit",
            textDecoration: "none",
            "&:hover": {
                textDecoration: "underline",
            },
        },
    },
    "& .tagsSectionPills": {},
    "& .tagsSectionWave": {
        flexBasis: toRem(100),
        minWidth: toRem(100),
        flex: "auto",
    },
});

export default style;
